/**
 * RiskFiltersPanel
 * Filtros rápidos por fornecedor (multi-marca) e por marca.
 */

import React from 'react'
import { Building2, Tag } from 'lucide-react'
import './RiskFiltersPanel.css'

function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0
  }).format(value || 0)
}

function RiskStats({ critical, high, medium }) {
  return (
    <span className="risk-filters-stats">
      {critical > 0 && <em className="critical">{critical} crít.</em>}
      {high > 0 && <em className="high">{high} alto</em>}
      {medium > 0 && <em className="medium">{medium} méd.</em>}
    </span>
  )
}

function RiskFiltersPanel({
  suppliers = [],
  brands = [],
  supplierFilter,
  brandFilter,
  onSupplierChange,
  onBrandChange,
  onClearFilters
}) {
  const hasFilters = Boolean(supplierFilter || brandFilter)

  if (!suppliers.length && !brands.length) return null

  return (
    <section className="risk-filters-panel">
      <div className="risk-filters-panel-header">
        <div>
          <h2 className="risk-filters-panel-title">Risco por fornecedor e marca</h2>
          <p className="risk-filters-panel-subtitle">
            Fornecedores identificados nas entradas de estoque (ex.: distribuidores multi-marca)
          </p>
        </div>
        {hasFilters && (
          <button type="button" className="risk-filters-clear-btn" onClick={onClearFilters}>
            Limpar filtros
          </button>
        )}
      </div>

      {suppliers.length > 0 && (
        <div className="risk-filters-group">
          <h3 className="risk-filters-group-title">
            <Building2 size={14} />
            Fornecedores
          </h3>
          <div className="risk-filters-grid">
            {suppliers.map((row) => (
              <button
                key={row.supplierId}
                type="button"
                className={`risk-filters-supplier-card ${supplierFilter === String(row.supplierId) ? 'is-active' : ''}`}
                onClick={() => onSupplierChange(
                  supplierFilter === String(row.supplierId) ? '' : String(row.supplierId)
                )}
              >
                <span className="risk-filters-supplier-name">{row.supplierName}</span>
                <span className="risk-filters-supplier-meta">
                  {row.isMultiBrand && (
                    <span className="risk-filters-multi-badge">{row.brandCount} marcas</span>
                  )}
                  <span>{row.productCount} produto(s)</span>
                  <span>{formatCurrency(row.suggestedValue)}</span>
                </span>
                <RiskStats critical={row.critical} high={row.high} medium={row.medium} />
              </button>
            ))}
          </div>
        </div>
      )}

      {brands.length > 0 && (
        <div className="risk-filters-group">
          <h3 className="risk-filters-group-title">
            <Tag size={14} />
            Marcas
          </h3>
          <div className="risk-filters-chips">
            {brands.map((row) => (
              <button
                key={row.brand}
                type="button"
                className={`risk-filters-brand-chip ${brandFilter === row.brand ? 'is-active' : ''}`}
                onClick={() => onBrandChange(brandFilter === row.brand ? '' : row.brand)}
              >
                <span className="risk-filters-brand-name">{row.brand}</span>
                <RiskStats critical={row.critical} high={row.high} medium={row.medium} />
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  )
}

export default RiskFiltersPanel
